<template lang="pug">
  #ContactsIndex
    b-card.rounded-0.m-3(
      bg-variant="light",
      no-body
    )
      b-card-body.py-2.px-3(
        class="searchArea"
      )
        b-collapse#collapse-searchBody(
          visible
        )
          b-input-group.my-2.d-flex.align-items-center
            b-form-input.pr-6(
              v-model="searchInput.customer_name",
              placeholder="請輸入關鍵字搜尋"
            )
            i.fas.fa-search.inputInnerIcon(@click="searchHandler()")
          .row.no-gutters.mt-3
            .col-1
            .col-4
              b-button.btn-sm(
                variant="primary",
                block,
                @click="resetSearchHandler()"
              ) 清除
            .col-2
            .col-4
              b-button.btn-sm(
                variant="primary",
                block,
                @click="searchHandler()"
              ) 確認
    .mx-4.my-3.d-flex.align-items-center
      i.fas.fa-users.fa-lg
      span.pl-2 {{ pagination.total || 0 }} 位
      b-button(
        variant="primary",
        size="sm",
        @click="selectAllUsers()",
        :class="['select-all-btn ml-2', { selected: isAllSelected }]",
        v-show="selectMode"
      )
        i(:class="['btn-icon fas', isAllSelected ? 'fa-check' : 'fa-plus', { rotate: isSelectAllAnimating }]")
        | {{ selectAllButtonText }}
    .root.mx-3(ref="root" :style="rootStyle")
      .viewport(ref="viewport" :style="viewportStyle")
        .spacer(ref="spacer" :style="spacerStyle")
          b-card.border-0.mb-2.customerCard.overflow-hidden(
            bg-variant="light",
            v-for="(user,index) in visibleItems",
            :key="user.member_id",
            @click="showUserInfoHandler(user.member_id)"
          )
            .row
              .col-2.d-flex.align-items-center.justify-content-center(
                v-show="selectMode"
              )
                b-form-checkbox(
                  :id="`checkbox-group-${index}`",
                  v-model="selectUsers",
                  :name="`user-${index}`",
                  :value="user",
                  v-show="selectMode",
                  @change="handleSingleSelection"
                )
              div(
                :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
              )
                label.w-100.mb-0(
                  :for="`checkbox-group-${index}`"
                )
                  .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
                    .col-6.pr-1
                      ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                        :profileUrl="user.picture_url",
                        :style="{ 'width': '80px', 'height': '80px' }"
                      )
                    .col-6.pl-1
                      p.mb-0.font-weight-bold 姓名 {{ user.chinese_first_name }}
                      p.mb-0 暱稱名 {{ user.line_display_name ? user.line_display_name : '-' }}
                  .reserveAtRow.mb-2.d-flex.align-items-center
                    small 備註名：{{ user.note_name ? user.note_name : '無' }}
                  .reserveAtRow.mb-2.d-flex.align-items-center
                    i.fas.fa-mobile-alt.pr-1
                      small.pl-3 電話：{{ user.mobile ? user.mobile : '無' }}
                  .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                    i.fas.fa-tag
                      small.pl-2 客戶標籤：
                        small(
                          v-if="user.tags && user.tags.length > 0"
                        )
                          b-badge.m-1.rounded-50.px-2.py-1(
                            variant="primary",
                            v-for="tag in user.tags"
                            :key="tag.type + tag.tag_id"
                          ) {{ tag.name }}
                        small(
                          v-else
                        ) 無
          infinite-loading(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles"
          )
            .cursor-default(slot="no-more") 無更多資料
            .cursor-default(slot="no-results") 無更多資料
            .cursor-default(slot="error") 發生錯誤，請重整重試一次
    //- 群發訊息按鈕
    .button-fixedArea(:style="selectMode ? 'bottom: 30%' : ''")
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.iconBtn.iconPushBtn(
        variant="primary",
        @click="selectUserHandler(true)"
      )
        i.fas.fa-volume-up.iconPush
      small.d-block.w-100.text-center.my-1 群發訊息
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.iconBtn.iconPushBtn(
        variant="primary",
        v-if="selectMode",
        @click="selectAllUserHandler()"
      )
        i.fas.fa-volume-up.iconPush
      small.d-block.w-100.text-center.my-1(v-if="selectMode") 全體發送
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.button-close.iconBtn.iconPushBtn(
        variant="gray",
        v-if="selectMode",
        @click="selectUserHandler(false)"
      )
        i.fas.fa-times
      b-badge.rounded-50.d-flex.align-items-center.justify-content-center.button.button-people.iconBtn.iconPushBtn.p-1(
        pill,
        variant="danger",
        v-if="selectMode"
      )
        span {{ selectUsers.length }}
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_GROUP_PUSH_INDEX } from '@/router/sm/group-push';
import { SM_MY_CUSTOMER_INDEX } from '@/router/sm/my-customer';

const passiveSupportMixin = {
  methods: {
    // This snippet is taken straight from https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    // It will only work on browser so if you are using in an SSR environment, keep your eyes open
    doesBrowserSupportPassiveScroll() {
      let passiveSupported = false;

      try {
        const options = {
          get passive() {
            // This function will be called when the browser
            //   attempts to access the passive property.
            passiveSupported = true;
            return false;
          },
        };

        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
      } catch (err) {
        passiveSupported = false;
      }
      return passiveSupported;
    },
  },
};
export default {
  name: "ContactsIndex",
  mixins: [passiveSupportMixin],
  components: {
    ProfilePhotoSticker,
    InfiniteLoading,
  },
  data() {
    return {
      searchInput: {
        customer_name: null,
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date(),
      getAllData: false,
      // Total height of the root which contains all the list items in px
      rootHeight: 500,
      // Height of each row, give it an initial value but this gets calculated dynamically on mounted
      rowHeight: 100,
      // Current scroll top position, we update this inside the scroll event handler
      scrollTop: 0,
      // Extra padding at the top and bottom so that the items transition smoothly
      // Think of it as extra items just before the viewport starts and just after the viewport ends
      nodePadding: 20,
      // 控制全選按鈕動畫和狀態
      isSelectAllAnimating: false,
      // 追蹤之前的全選狀態，用於判斷狀態變化
      previousAllSelectedState: false,
    };
  },
  mounted() {
    this.$refs.root.addEventListener(
      "scroll",
      this.handleScroll,
      this.doesBrowserSupportPassiveScroll() ? { passive: true } : false
    );
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
    vm.$store.commit('sm_contacts/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sm_contacts/getMemberListHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: 99999999999,
        keyword: vm.searchInput.customer_name
      }).then(async () => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
          if (vm.getAllData) {
            vm.selectUsers = [...vm.memberList]; // 使用展開運算符創建新陣列
            vm.getAllData = false;
          }
        }
        const largestHeight = await this.calculateInitialRowHeight();
        this.rowHeight =
          typeof largestHeight !== "undefined" && largestHeight !== null && !Number.isNaN(largestHeight)
            ? largestHeight
            : 30;
      });
    },
    selectUserHandler(mode) {
      const vm = this;
      // 如果是點推播按鈕且目前在選擇使用者模式
      if (
        mode &&
        vm.selectMode &&
        vm.selectUsers &&
        vm.selectUsers.length > 0
      ) {
        vm.$store.commit('sm_group_push/setMemberList', vm.selectUsers);
        vm.$router.push({
          name: SM_GROUP_PUSH_INDEX,
        });
      } else {
        vm.selectUsers = [];
        vm.selectMode = mode;
      }
    },
    showUserInfoHandler(userId) {
      const vm = this;
      if (vm.selectMode) return;
      vm.$router.push({
        name: SM_MY_CUSTOMER_INDEX,
        params: {
          userId,
        },
      }).catch(() => {});
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.customer_name) return;
      vm.$store.commit('sm_contacts/resetHandler');
      vm.infiniteId += 1;
    },
    resetSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.$store.commit('sm_contacts/resetHandler');
      vm.infiniteId += 1;
    },
    selectAllUserHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '取得全體顧客中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_contacts/getAllMemberListHandler', {
        current_page: 1,
        per_page: 999999
      }).then((res) => {
        vm.$swal.close();
        vm.$store.commit('sm_group_push/setMemberList', res.data.members);
        vm.$router.push({
          name: SM_GROUP_PUSH_INDEX
        });
      });
    },
    selectAllUsers() {
      const vm = this;

      // 觸發動畫
      vm.isSelectAllAnimating = true;

      // 如果當前是全選狀態，則取消全選
      if (vm.isAllSelected) {
        vm.selectUsers = [];
        vm.isSelectAllAnimating = false;
        vm.previousAllSelectedState = false;
        return;
      }

      // 如果資料未完全載入，需要先載入所有資料
      if (vm.memberList.length !== vm.pagination.total) {
        vm.getAllData = true;
        vm.$store.commit('sm_contacts/resetHandler');
        vm.infiniteId += 1;
      } else {
        // 直接全選當前已載入的資料
        vm.selectUsers = [...vm.memberList];
        vm.previousAllSelectedState = true;
      }
    },
    handleScroll(event) {
      this.scrollTop = this.$refs.root.scrollTop;
    },
    /**
    Find the largest height amongst all the children
    Remember each row has to be of the same height
    I am working on the different height version
    */
    calculateInitialRowHeight() {
      return new Promise((resolve) => {
        const children = this.$refs.spacer.children;
        let largestHeight = 200;
        let height = 0;
        for (let i = 0; i < children.length; i++) {
          if (children[i].offsetHeight > largestHeight) {
            largestHeight = children[i].offsetHeight;
          }
          if (i !== children.length - 1)
            height += children[i].offsetHeight + 10;
        }
        const avg = Math.floor(height / Math.max(1, children.length - 1));
        resolve(avg > 0 ? avg : 500);
      });
    },
    // 處理單一選項變化
    handleSingleSelection() {
      const vm = this;

      // 使用 nextTick 確保 DOM 更新後再檢查狀態
      vm.$nextTick(() => {
        const currentAllSelectedState = vm.isAllSelected;

        // 如果之前是全選且有動畫，現在變成非全選，則立即停止動畫
        if (vm.previousAllSelectedState
            && vm.isSelectAllAnimating
            && !currentAllSelectedState) {
          vm.isSelectAllAnimating = false;
        }

        // 如果從非全選狀態變成全選狀態，可以觸發動畫
        if (!vm.isSelectAllAnimating
            && currentAllSelectedState
            && vm.selectUsers.length === vm.memberList.length) {
          vm.isSelectAllAnimating = true;
        }

        // 更新之前的狀態
        vm.previousAllSelectedState = currentAllSelectedState;
      });
    },
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sm_contacts.memberList,
      pagination: (state) => state.sm_contacts.pagination,
    }),
    /**
    Total height of the viewport = number of items in the array x height of each item
    */
    viewportHeight() {
      return this.itemCount * this.rowHeight + 120;
    },
    /**
    Out of all the items in the massive array, we only render a subset of them
    This is the starting index from which we show a few items
    */
    startIndex() {
      let startNode = Math.floor(this.scrollTop / this.rowHeight) - this.nodePadding;
      startNode = Math.max(0, startNode);
      return startNode;
    },
    /**
    This is the number of items we show after the starting index
    If the array has a total 10000 items, we want to show items from say index 1049 till 1069
    visible node count is that number 20 and starting index is 1049
    */
    visibleNodeCount() {
      let count = Math.ceil(this.rootHeight / this.rowHeight) + 2 * this.nodePadding;
      count = Math.min(this.itemCount - this.startIndex, count);
      return count;
    },
    /**
    Subset of items shown from the full array
    */
    visibleItems() {
      return this.memberList.slice(
        this.startIndex,
        this.startIndex + this.visibleNodeCount
      );
    },
    itemCount() {
      return this.memberList.length;
    },
    /**
    The amount by which we need to translateY the items shown on the screen so that the scrollbar shows up correctly
    */
    offsetY() {
      return this.startIndex * this.rowHeight;
    },
    /**
    This is the direct list container, we apply a translateY to this
    */
    spacerStyle() {
      return {
        transform: "translateY(" + this.offsetY + "px)",
      };
    },
    viewportStyle() {
      return {
        overflow: "hidden",
        height: this.viewportHeight + "px",
        position: "relative",
      };
    },
    rootStyle() {
      return {
        height: this.rootHeight + "px",
        overflow: "auto",
      };
    },
    // 判斷是否全選
    isAllSelected() {
      return this.memberList.length > 0
        && this.selectUsers.length === this.memberList.length
        && this.memberList.every((member) => this.selectUsers.some((selected) => selected.member_id === member.member_id));
    },
    // 全選按鈕文字
    selectAllButtonText() {
      return this.isAllSelected ? '取消全選' : '全選顧客';
    },
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;

    // 先清理事件监听器
    if (vm.$refs.root) {
      vm.$refs.root.removeEventListener("scroll", vm.handleScroll);
    }

    // 再重置 store 数据
    vm.$store.commit('sm_contacts/resetHandler');

    next();
  },
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all 0.3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.iconPushBtn {
  background: #b2a392;
  border: #b2a392;
}

.inputInnerIcon {
  position: absolute;
  right: 10px;
  z-index: 10;
}

/* 全選按鈕樣式 */
.select-all-btn {
  border: 2px solid $COLOR;
  border-radius: 20px;
  background-color: white;
  color: #6c757d;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: center;

  &:hover {
    background-color: #f8f9fa;
    text-decoration: none;
    color: #6c757d;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &.selected {
    border-color: $COLOR;
    background-color: $COLOR;
    color: white;
    box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);

    &:hover {
      background-color: lighten($COLOR, 10%);
      border-color: lighten($COLOR, 10%);
    }
  }

  .btn-icon {
    -webkit-transition: -webkit-transform .3s ease-in-out;
    transition: -webkit-transform .3s ease-in-out;
    -o-transition: transform .3s ease-in-out;
    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;

    &.rotate {
      -webkit-transform: rotate(-360deg);
      -ms-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }
}
</style>
